/* eslint-disable react/prop-types */
import Tippy from '@tippyjs/react';
import React from 'react';
import styled from 'styled-components';

export const StyledTippy = styled(Tippy)`
	.tippy-content {
		font-family: Roboto;
		font-size: 10px;
		font-weight: 400;
		line-height: 11px;
		margin: 0;
		color: #fff;
	}
`;

function UITippy(props) {
	const { children, ...restOf } = props;

	return <StyledTippy {...restOf}>{children}</StyledTippy>;
}

export default UITippy;
